const MINUTES_UNIT = 'MINUTES';

export const readStepTimesMap = (applicationId) => {
    const key = applicationId ? `stepTimes_${applicationId}` : 'stepTimes_default';
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

export const msToFlooredMinutes = (ms) =>
    Math.floor((Number(ms) || 0) / 60000);

/**
 * Builds the PUT body for application .../completionDuration.
 * Step times in localStorage are keyed by form schemaCategory; each entry maps to that form's id.
 */
export const buildCompletionDurationPayload = (applicationId, basicForm) => {
    const totalKey = applicationId ? `totalTime_${applicationId}` : 'totalTime';
    const totalMs = parseFloat(localStorage.getItem(totalKey) || '0') || 0;
    const stepTimes = readStepTimesMap(applicationId);
    const forms = basicForm?.forms ?? [];
    const formDurations = forms
        .filter((f) => f?.id != null && f?.id !== '')
        .map((f) => ({
            formId: String(f.id),
            duration: {
                value: msToFlooredMinutes(stepTimes[f.schemaCategory] || 0),
                unit: MINUTES_UNIT,
            },
        }));

    return {
        overallDuration: {
            value: msToFlooredMinutes(totalMs),
            unit: MINUTES_UNIT,
        },
        formDurations,
    };
};

/** Minutes from API (overall); supports new overallDuration and legacy completionDuration. */
export const getOverallDurationMinutesFromBasicForm = (basicForm) => {
    const v =
        basicForm?.overallDuration?.value ?? basicForm?.completionDuration?.value;
    if (v == null || v === '') return null;
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : null;
};
